import { Center, Container, Stack, Text } from "@mantine/core";

const Footer = () => {
  return (
    <Center>
      <Container py={{ base: 48, md: 64 }} component="footer">
        <Stack>
          <Center>
            <Text size="sm" c="dimmed">
              Made with 🧡 by your friends & neighbors from Tech Team
            </Text>
          </Center>
        </Stack>
      </Container>
    </Center>
  );
};

export default Footer;